"use client";

import * as React from "react";
import cx from "clsx";
import SeatLegend from "./components/SeatLegend";
import Stack from "../Stack";
import Text from "../Text";
import { useRandomIdSeed } from "../hooks/useRandomId";
import SeatNormal from "./components/SeatNormal";
import SeatSmall from "./components/SeatSmall";
import SeatCircle from "./components/SeatCircle";
import { SIZE_OPTIONS, TYPES } from "./consts";
const Seat = ({
  type = TYPES.DEFAULT,
  selected = false,
  onClick,
  size = SIZE_OPTIONS.MEDIUM,
  dataTest,
  id,
  price,
  label,
  title = "Seat",
  description = "Presents options for seating"
}) => {
  const randomId = useRandomIdSeed();
  const titleId = randomId("title");
  const descrId = randomId("descr");
  const clickable = type !== TYPES.UNAVAILABLE;
  return /*#__PURE__*/React.createElement(Stack, {
    inline: true,
    grow: false,
    spacing: "XXXSmall",
    direction: "column",
    align: "center"
  }, /*#__PURE__*/React.createElement("button", {
    className: cx("orbit-seat font-base group relative", size === SIZE_OPTIONS.SMALL ? "w-xl h-[36px]" : "size-[46px]"),
    "data-test": dataTest,
    id: id,
    disabled: !clickable,
    onClick: clickable ? onClick : undefined,
    tabIndex: clickable ? 0 : -1,
    type: "button"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: size === SIZE_OPTIONS.SMALL ? "0 0 32 36" : "0 0 46 46",
    "aria-labelledby": `${titleId} ${descrId}`,
    fill: "none",
    role: "img"
  }, /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), /*#__PURE__*/React.createElement("desc", {
    id: descrId
  }, description), size === SIZE_OPTIONS.SMALL ? /*#__PURE__*/React.createElement(SeatSmall, {
    type: type,
    selected: selected,
    label: label
  }) : /*#__PURE__*/React.createElement(SeatNormal, {
    type: type,
    selected: selected,
    label: label
  })), selected && clickable && /*#__PURE__*/React.createElement(SeatCircle, {
    size: size,
    type: type
  })), price && !(selected && type === TYPES.UNAVAILABLE) && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    type: "secondary"
  }, price));
};
export { SeatLegend };
export default Seat;